/**
 *  Standard paging composition for jobs
 */
import jobActionCreators from '../../../actions/jobActionCreators';
import pagingComposition from '../../common/pagingTable/pagingComposition';
export default pagingComposition(
// these are specific to documents.
'job',
// these describe the column to attribute mapping.  this is used for
// sending sorting queries to the server.
jobActionCreators, {
  'Job Number': 'jobNumber',
  Name: 'name'
});